module.exports = __webpack_public_path__ + "static/media/monticello.645768fe.png";